import selfAssessmentDetailsLocale from './en.json'

const en = {
  selfAssessmentDetails: selfAssessmentDetailsLocale,
}

export default en
